import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import Header from '../components/Header';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    messages: 0,
    services: 0,
    brands: 0,
    blogPosts: 0,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    const [messages, services, brands, blogPosts] = await Promise.all([
      supabase.from('contact_messages').select('id', { count: 'exact', head: true }),
      supabase.from('services').select('id', { count: 'exact', head: true }),
      supabase.from('brands').select('id', { count: 'exact', head: true }),
      supabase.from('blog_posts').select('id', { count: 'exact', head: true }),
    ]);

    setStats({
      messages: messages.count || 0,
      services: services.count || 0,
      brands: brands.count || 0,
      blogPosts: blogPosts.count || 0,
    });
  };

  const statCards = [
    { icon: 'ri-mail-line', label: 'Toplam Mesaj', value: stats.messages, color: 'bg-blue-500' },
    { icon: 'ri-tools-line', label: 'Hizmetler', value: stats.services, color: 'bg-teal-500' },
    { icon: 'ri-building-line', label: 'Markalar', value: stats.brands, color: 'bg-purple-500' },
    { icon: 'ri-article-line', label: 'Blog Yazıları', value: stats.blogPosts, color: 'bg-orange-500' },
  ];

  return (
    <div>
      <Header 
        title="Dashboard" 
        subtitle="Yönetim paneline hoş geldiniz"
      />

      <div className="p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {statCards.map((stat) => (
            <div key={stat.label} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
                  <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`${stat.color} w-12 h-12 rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Hızlı Erişim</h3>
            <div className="space-y-3">
              <a href="/admin/settings" className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-settings-3-line text-xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-sm text-gray-700">Site Ayarları</span>
              </a>
              <a href="/admin/blog" className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-article-line text-xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-sm text-gray-700">Yeni Blog Yazısı</span>
              </a>
              <a href="/admin/pages" className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-pages-line text-xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-sm text-gray-700">Sayfa Oluştur</span>
              </a>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Sistem Bilgisi</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">Supabase</span>
                <span className="text-green-600 font-medium">Bağlı</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">Veritabanı</span>
                <span className="text-green-600 font-medium">Aktif</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-gray-600">Versiyon</span>
                <span className="text-gray-900 font-medium">1.0.0</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
